import ninegrid from "../index.js";
import {nxDiv} from "./_nxDiv.js";

class nxTitle2 extends nxDiv {

	#changed = false;

	constructor() {
		super();
	}

	connectedCallback() {
		if (super.connectedCallback()) this.#init();
	};

	get changed() {
		return this.#changed;
	};
	set changed(v) {
		this.#changed = v;
		v ? this.classList.add("changed") : this.classList.remove("changed");
	};

	#init = () => {
		const caption = this.getAttribute("caption") || "";
		const htmlTmpl = document.createElement("template");

		htmlTmpl.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxTitle2.css";
				${ninegrid.getCustomPath(this,"nxTitle2.css")}
			</style>
            
            <div class="left">
            	<span>${caption}</span>
			</div>
			
            ${this.originContents}
        `;

		(this.shadowRoot || this).appendChild(htmlTmpl.content.cloneNode(true));
	}
}

if (!customElements.get('nx-title2')) {
	customElements.define("nx-title2", nxTitle2);
}
